const fixed_header = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

fixed_header(() => {
   // Getting the header element
   const header = document.querySelector('.wcl-main-header');

   // Define a function for adding/removing a class
   function toggleHeaderFixed() {
      if (window.scrollY > 0) {
         header.classList.add('fixed');
      } else {
         header.classList.remove('fixed');
      }
   }

   // Listen to the page scroll event and call the function toggleHeaderFixed
   window.addEventListener('scroll', toggleHeaderFixed);
});